export default __webpack_public_path__ + "static/media/045-pressure cooker.30cfd077.svg";